import React from 'react';
import styled from 'styled-components';

const HistoryContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

const HistoryButton = styled.button`
  padding: 5px 10px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  &:hover {
    background-color: ${props => props.disabled ? '#333' : '#555'};
  }
`;

const HistoryControl = ({ canUndo, canRedo, onUndo, onRedo }) => {
  return (
    <HistoryContainer>
      <HistoryButton 
        onClick={onUndo} 
        disabled={!canUndo}
        title="Undo"
      >
        ↩ Undo
      </HistoryButton>
      <HistoryButton 
        onClick={onRedo} 
        disabled={!canRedo}
        title="Redo"
      >
        Redo ↪
      </HistoryButton>
    </HistoryContainer>
  );
};

export default HistoryControl; 